// extracted by mini-css-extract-plugin
export var section = "section_NmfiW1k2nxHzxvX54agg";
export var sectionDragHandle = "section__drag-handle_Fpz_Z9AVXUTUgAgg_wXe";